module.exports = __webpack_public_path__ + "static/media/HanWangMingBold.64c8aa7f.svg";